import PropTypes from "prop-types";
import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Badge,
} from "reactstrap";
import { Link } from "react-router-dom";

// Pages Components
import WelcomeComp from "./WelcomeComp";
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

//redux
import { useSelector, useDispatch } from "react-redux";

import {
  getProjectsNew as onGetProjectsNew,
  getRecipes as onGetRecipes,
  getRecipesReview as onGetRecipesReview,
  getUsers as onGetUsers,
  getNews as onGetNews,
  getSlider as onGetSlider,
} from "store/contacts/actions";

const StatCard = ({ title, count, icon, color, link }) => (
  <Link to={link} className="text-decoration-none">
    <Card className="mini-stats-wid h-100">
      <CardBody>
        <div className="d-flex">
          <div className="flex-grow-1">
            <p className="text-muted fw-medium">{title}</p>
            <h4 className="mb-0" style={{ color }}>{count}</h4>
          </div>
          <div
            className="avatar-sm rounded-circle align-self-center mini-stat-icon"
            style={{ backgroundColor: color + "20" }}
          >
            <span
              className="avatar-title rounded-circle"
              style={{ backgroundColor: color + "20", color }}
            >
              <i className={"bx " + icon + " font-size-24"}></i>
            </span>
          </div>
        </div>
      </CardBody>
    </Card>
  </Link>
);

const Dashboard = props => {
  const dispatch = useDispatch();

  const { projects, recipesR, recipesReview, users, news, slider } = useSelector(
    state => ({
      projects: state.contacts.projects || [],
      recipesR: state.contacts.recipesR || [],
      recipesReview: state.contacts.recipesReview || [],
      users: state.contacts.users || [],
      news: state.contacts.news || [],
      slider: state.contacts.slider || [],
    })
  );

  useEffect(() => {
    dispatch(onGetUsers());
    dispatch(onGetProjectsNew());
    dispatch(onGetRecipes());
    dispatch(onGetRecipesReview());
    dispatch(onGetNews());
    dispatch(onGetSlider());
  }, [dispatch]);

  //meta title
  document.title = "Anasayfa | Buhara Admin Paneli";

  const stats = [
    { title: "Toplam Ürünler", count: projects.length, icon: "bx-box", color: "#556ee6", link: "/projects" },
    { title: "Toplam Tarifler", count: recipesR.length, icon: "bx-book", color: "#34c38f", link: "/recipes" },
    { title: "Toplam Haberler", count: news.length, icon: "bx-news", color: "#f46a6a", link: "/news" },
    { title: "Toplam Slider", count: slider.length, icon: "bx-slideshow", color: "#f1b44c", link: "/slider" },
    { title: "Toplam Kullanıcılar", count: users.length, icon: "bx-user", color: "#50a5f1", link: "/usersList" },
    { title: "Toplam Yorumlar", count: recipesReview.length, icon: "bx-message-square-detail", color: "#7c5cc4", link: "/recipes" },
  ];

  const recentProjects = [...projects].reverse().slice(0, 5);
  const recentRecipes = [...recipesR].reverse().slice(0, 5);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Yönetim")}
            breadcrumbItem={props.t("Anasayfa")}
          />

          <Row>
            <Col xl="4">
              <WelcomeComp />
            </Col>
            <Col xl="8">
              <Row>
                {stats.map((stat, key) => (
                  <Col md="4" key={"_stat_" + key} className="mb-3">
                    <StatCard {...stat} />
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          <Row>
            <Col xl="6">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="card-title mb-0">Son Eklenen Ürünler</h5>
                    <Link to="/projects" className="btn btn-sm btn-primary">
                      Tümünü Gör
                    </Link>
                  </div>
                  <div className="table-responsive">
                    <Table className="table-hover table-centered table-nowrap mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>ID</th>
                          <th>Ürün Adı</th>
                          <th>Durum</th>
                        </tr>
                      </thead>
                      <tbody>
                        {recentProjects.length > 0 ? (
                          recentProjects.map((item, idx) => (
                            <tr key={idx}>
                              <td className="fw-medium">#{item.ID}</td>
                              <td>{item.Products_Name || "-"}</td>
                              <td>
                                <Badge color="success" pill>
                                  Aktif
                                </Badge>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center text-muted py-3">
                              Henüz ürün eklenmemiş.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl="6">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="card-title mb-0">Son Eklenen Tarifler</h5>
                    <Link to="/recipes" className="btn btn-sm btn-primary">
                      Tümünü Gör
                    </Link>
                  </div>
                  <div className="table-responsive">
                    <Table className="table-hover table-centered table-nowrap mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>ID</th>
                          <th>Tarif Adı</th>
                          <th>Durum</th>
                        </tr>
                      </thead>
                      <tbody>
                        {recentRecipes.length > 0 ? (
                          recentRecipes.map((item, idx) => (
                            <tr key={idx}>
                              <td className="fw-medium">#{item.ID}</td>
                              <td>{item.Recipes_Title || "-"}</td>
                              <td>
                                <Badge color="success" pill>
                                  Aktif
                                </Badge>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center text-muted py-3">
                              Henüz tarif eklenmemiş.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Dashboard);
